import { render, staticRenderFns } from "./ResidentsCareimageTable.vue?vue&type=template&id=11f905d6&scoped=true&lang=pug"
import script from "./ResidentsCareimageTable.vue?vue&type=script&lang=ts"
export * from "./ResidentsCareimageTable.vue?vue&type=script&lang=ts"
import style0 from "./ResidentsCareimageTable.vue?vue&type=style&index=0&id=11f905d6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11f905d6",
  null
  
)

export default component.exports